module.exports = __webpack_public_path__ + "static/media/password-invisible.702f70b5.png";